module.exports = __webpack_public_path__ + "static/event-social-entrepreneurship-1393364085dbff91c3cdfc1c84b31d1e.jpg";